import React from 'react'
import { Box, Button } from '@mui/material'
import { ContentCopy, Edit, Help, Settings, VolumeDown } from '@mui/icons-material'
import { DisplayTool } from './VocabularyTools'

interface CardsPlayToolsProps {
  displayTools: DisplayTool
  setDisplayTools: React.Dispatch<React.SetStateAction<DisplayTool>>
  onEdit: () => void
  onDemo: () => void
  onSetup: () => void
}

const CardsPlayTools: React.FC<CardsPlayToolsProps> = (
  {
    displayTools,
    setDisplayTools,
    onEdit,
    onDemo,
    onSetup,
  }) => (
  <Box display="flex" justifyContent="space-between">
    <Button color="secondary" onClick={onSetup}>
      <Settings />
    </Button>
    <Button
      color="secondary"
      onClick={() => setDisplayTools(displayTools !== 'pronounce' ? 'pronounce' : '')}
    >
      <VolumeDown />
    </Button>
    <Button color="secondary" onClick={onEdit}>
      <Edit />
    </Button>
    <Button
      color="secondary"
      onClick={() => setDisplayTools(displayTools !== 'copy' ? 'copy' : '')}
    >
      <ContentCopy />
    </Button>
    <Button color="secondary" onClick={onDemo}>
      <Help />
    </Button>
  </Box>
)

export default CardsPlayTools
